<template lang="pug" src="./card-editor.pug"></template>
<style lang="scss" src="./card-editor.scss" scoped></style>

<script>
import { validationMixin } from 'vuelidate';
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';
import { vLength, normalizedPhone } from '@/utils/helpers';

export default {
    mixins: [validate, validationMixin],
    props: {
        card: {
            type: Object,
            default: () => {}
        },
        reasons: {
            type: Array,
            default: () => []
        },
        types: {
            type: Array,
            default: () => []
        },
        statuses: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
       canSaveCard: false
    }),
    validations: {
        card: {
            ...Object.assign({}, ...[
                'type', 'reason', 'status'
            ].map(param => ({
                [param]: {
                    required
                }
            }))),
            customReason: {
                required: requiredIf(function() {
                    return this.showCustomReason;
                })
            },
            phoneNumber: {
                required,
                length: vLength(9)
            },
            comment: {
                maxLength: maxLength(255)
            }
        }
    },
    computed: {
        showCustomReason() {
            return this.card.reason === 'custom';
        },
        isEditing() {
            return !!this.card.id;
        },
        saveParams() {
            const method = this.isEditing ? 'put' : 'post';
            const url = this.isEditing ? `support/technical/${this.card.id}` : 'support/technical';
            const buttonType = this.isEditing ? 'save' : 'create';

            return {
                url, method,
                text: this.$vuetify.lang.t(`$vuetify.buttons.${buttonType}`)
            };
        }
    },
    watch: {
        card: {
            handler: function (val) {
                this.canSaveCard = true;
                this.$store.commit('technicalSupport/SET_CARD_DATA', val);
            },
            deep: true
        }
    },
    methods: {
        saveCard() {
            if (this.$v.card.$invalid) {
                this.$v.card.$touch();
                return;
            }

            this.$store.dispatch('technicalSupport/saveCard', {
                ...Object.select(this.saveParams, ['url', 'method']),
                ...this.card,
                phoneNumber: normalizedPhone(this.card.phoneNumber)
            }).then(status => {
                if (status && [200, 201].includes(status)) {
                    this.$v.card.$reset();
                    this.$emit('reset');
                }
            });
        }
    }
};
</script>
